// extracted by mini-css-extract-plugin
module.exports = {"refreshButton":"RefreshQueryButton_refreshButton__mXfJn"};